<template>
	<div class="accessories-list">
		<hr>
		<h3 class="accessories-list-heading">
			Accessories
		</h3>
		<hr>
		<template v-for="(accessory, type) in accessories">
			<template v-for="item in accessory">
				<accessory-item
					:key="`list-accessory-${item.products_id}-${item.id}`"
					:accessory="item"
					:type="type"
				/>
			</template>
		</template>
		<template v-if="noAccessoriesSelected">
			<p class="no-items">
				No accessories were selected.
			</p>
			<hr>
		</template>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import AccessoryItem from "./accessory-item";
import _isEmpty from "lodash/isEmpty";

export default {
	name: "AccessoriesList",
	components: {
		AccessoryItem
	},
	computed: {
		...mapGetters({
			accessories: "PrebuildSeries/getSeriesAccessories",
			currentAccessories: "PrebuildSeries/getCurrentAccessories"
		}),
		noAccessoriesSelected() {
			return _isEmpty(this.currentAccessories);
		}
	}
};
</script>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

.accessories-list {
	&-heading {
		color: $black;
		margin: 33px 0 33px 25px;

		@media (min-width: 320px) and (max-width: 580px) {
			margin: 33px 0 33px 0;
		}
	}

	.no-items {
		margin: 33px 0 33px 65px;
	}
}

hr {
	border-top: 1px solid #dadde0;
	margin: 0;
}
</style>
